import { STUDENT, CHECKED } from '../actions/StudentActions'

function initialState() {
  return {
    selectedStudent: {},
  }
}

export default function selectedStudent(state = initialState(), action) {
  switch (action.type) {
    case STUDENT:
      return state
        ? { ...state, selectedStudent: action.payload }
        : { selectedStudent: action.payload }
    case CHECKED:
      return state
        ? { ...state, setIfAnswerIsChecked: action.payload }
        : { selectedStudent: action.payload }
    default:
      return state
  }
}
